// extracted by mini-css-extract-plugin
module.exports = {"notificationContainer":"Notification_notificationContainer__28I1K"};